import React from 'react';

const Error503Page = () => {
    return (
        <div className="relative flex size-full min-h-screen flex-col bg-white">
            <div className="px-20 lg:px-40 xl:px-40 flex flex-1 justify-center py-5 font-sans">
                <div className="flex flex-col w-full max-w-2xl py-5 flex-1">
                    <div className="flex flex-col items-center justify-center gap-3 p-4">
                        <div className="text-center">
                            <p className="text-[#111218] tracking-light text-2xl sm:text-3xl lg:text-[32px] font-bold leading-tight m-0">
                                503 Service Unavailable
                            </p>
                            <p className="text-[#5f678c] text-sm font-normal leading-normal mt-4">
                                Sorry, we'll be right back.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Error503Page;
